module.exports = __webpack_public_path__ + "static/media/fujitsu.eafdd543.png";